import React, { useEffect } from "react"
import { Navigate } from "react-router-dom"
import { useAppDispatch, useAppSelector } from "../redux/hooks"
import { setUser } from "../redux/slices/authSlice"


interface Props {
  children: React.ReactNode
}
const ProtectedRoute: React.FC<Props> = ({ children }) => {
  const dispatch = useAppDispatch();
  const { token } = useAppSelector((state) => state.auth)
  const user = JSON.parse(localStorage.getItem("user") || "{}");

  useEffect(() => {
    if (!token) {
      localStorage.removeItem("user")
      localStorage.removeItem("token")
      localStorage.removeItem("refreshToken")
    }

  }, [token])

  useEffect(() => {
    if (user) {
      dispatch(setUser(user))
    }
  }, [])

  const protectedRroute = ["/interview-setup", "/interviews", "/dashboard", "/interview-scores", "/profile"]

  if (!token && !protectedRroute.includes(window.location.pathname)) {
    return <Navigate to="/login" replace />
  }

  if (!token)

    return <Navigate to="/home" replace />


  return <>{children}</>
}

export default ProtectedRoute
